export default __webpack_public_path__ + "static/media/plain-sticker-wi.3e6f8d56.png";